const persianNum = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

function changeToPersian(num) {
  if(!num || num === "NaN")
    return "۰";
  let resultNum = [];
  String(num)
    .split("")
    .forEach((number) => {
      if (persianNum[number]) resultNum.push(persianNum[number]);
      else resultNum.push(number);
    });
  return resultNum.join("");
}

function changeToEnglish(num) {
  let resultNum = [];
  const numArray = String(num).split("");
  numArray.forEach((number) => {
    if (persianNum.indexOf(number) != -1) {
      resultNum.push(persianNum.indexOf(number));
    } else resultNum.push(number);
  });
  return resultNum.join("");
}

export { changeToPersian, changeToEnglish };
